const AVATAR_COLORS = [
  "#605DEC", // OKO Blue
  "#BC165D", // OKO Dark Pink
  "#00A35A", // Success Green
  "#F7622B", // Orange 500
  "#FE1E7E", // Brand Pink Primary
];

// Face 1: Big open smile, circle right eye, wink left eye
const FaceA = () => (
  <>
    <path fillRule="evenodd" clipRule="evenodd" d="M40.2188 69.4688C39.2087 69.4688 38.3906 70.2868 38.3906 71.2969C38.3906 80.6111 47.6135 87.749 58.501 87.749C69.3878 87.749 78.6113 80.6102 78.6113 71.2969C78.6113 70.2869 77.7932 69.4688 76.7832 69.4688H40.2188ZM42.5176 73.125H74.482C73.3074 79.135 66.9364 84.0938 58.4998 84.0938C50.0632 84.0938 43.6925 79.135 42.5176 73.125Z" fill="white" />
    <path fillRule="evenodd" clipRule="evenodd" d="M78.6104 37.4761C83.6376 37.4761 87.751 41.5894 87.751 46.6167C87.751 51.644 83.6376 55.7573 78.6104 55.7573C73.5831 55.7573 69.4697 51.644 69.4697 46.6167C69.4697 41.5894 73.5831 37.4761 78.6104 37.4761ZM78.6104 41.1323C75.5619 41.1323 73.126 43.5683 73.126 46.6167C73.126 49.6651 75.5619 52.1011 78.6104 52.1011C81.6588 52.1011 84.0947 49.6651 84.0947 46.6167C84.0947 43.5683 81.6588 41.1323 78.6104 41.1323Z" fill="white" />
    <path fillRule="evenodd" clipRule="evenodd" d="M38.3896 37.4761C33.1155 37.4761 29.249 42.604 29.249 48.4448C29.249 48.9293 29.441 49.3954 29.7838 49.7383C30.1265 50.081 30.5927 50.273 31.0772 50.273C31.5617 50.273 32.0278 50.081 32.3706 49.7383C32.7134 49.3955 32.9054 48.9293 32.9054 48.4448C32.9054 44.1852 35.5882 41.1323 38.3897 41.1323C41.1913 41.1323 43.8741 44.1852 43.8741 48.4448C43.8741 48.9293 44.0661 49.3954 44.4088 49.7383C44.7516 50.081 45.2178 50.273 45.7023 50.273C46.1868 50.273 46.6529 50.081 46.9957 49.7383C47.3385 49.3955 47.5304 48.9293 47.5304 48.4448C47.5304 42.604 43.664 37.4761 38.3898 37.4761H38.3896Z" fill="white" />
  </>
);

// Face 2: Small smile, both eyes with U-shapes
const FaceB = () => (
  <>
    <path fillRule="evenodd" clipRule="evenodd" d="M77.4164 71.5137C76.9305 71.4954 76.4584 71.6742 76.1055 71.9996C71.4489 76.3079 65.261 78.8242 58.6659 78.8242C52.0708 78.8242 45.8824 76.308 41.2263 71.9996C40.4837 71.3167 39.3288 71.3625 38.6412 72.1004C38.3112 72.4579 38.137 72.93 38.1554 73.4204C38.1737 73.9062 38.3845 74.3646 38.742 74.6945C44.0633 79.6171 51.1344 82.4954 58.6652 82.4954C66.1957 82.4954 73.2674 79.617 78.5884 74.6945C78.9459 74.3645 79.1568 73.9062 79.1751 73.4204C79.1934 72.93 79.0193 72.4579 78.6893 72.1004C78.3593 71.7429 77.9009 71.5321 77.4151 71.5137H77.4164Z" fill="white" />
    <path fillRule="evenodd" clipRule="evenodd" d="M78.8342 50.1649C84.1234 50.1649 88.0009 45.0224 88.0009 39.1649C88.0009 38.6791 87.8084 38.2162 87.4646 37.8724C87.1209 37.5286 86.6534 37.3316 86.1675 37.3316C85.1546 37.3316 84.3342 38.1566 84.3342 39.1649C84.3342 43.4366 81.6437 46.4982 78.8342 46.4982C76.0246 46.4982 73.3342 43.4366 73.3342 39.1649C73.3342 38.6791 73.1417 38.2162 72.7979 37.8724C72.4542 37.5286 71.9867 37.3315 71.5008 37.3315C70.4879 37.3315 69.6675 38.1565 69.6675 39.1649C69.6675 45.0224 73.545 50.1649 78.8342 50.1649Z" fill="white" />
    <path fillRule="evenodd" clipRule="evenodd" d="M38.499 50.1649C43.7882 50.1649 47.6657 45.0224 47.6657 39.1649C47.6657 38.6791 47.4732 38.2162 47.1294 37.8724C46.7857 37.5286 46.3182 37.3316 45.8323 37.3316C44.8194 37.3316 43.999 38.1566 43.999 39.1649C43.999 43.4366 41.3085 46.4982 38.499 46.4982C35.6894 46.4982 32.999 43.4366 32.999 39.1649C32.999 38.6791 32.8065 38.2162 32.4627 37.8724C32.119 37.5286 31.6515 37.3315 31.1656 37.3315C30.1527 37.3315 29.3323 38.1565 29.3323 39.1649C29.3323 45.0224 33.2098 50.1649 38.499 50.1649Z" fill="white" />
  </>
);

const FACES = [FaceA, FaceB];

// Fisher-Yates shuffle using a seeded sequence — deterministic so all clients
// see the same color assignments for a given participant list.
const shuffleWithSeed = (array, roundSeed) => {
  const shuffled = [...array];
  let seed = roundSeed;
  for (let i = shuffled.length - 1; i > 0; i--) {
    seed = (seed * 16807 + 1) | 0;
    const r = (seed >>> 0) / 4294967296;
    const j = Math.floor(r * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};

// Each round of 5 uses all colors exactly once in a shuffled order.
// After the 5th student, a new round begins with a fresh shuffle.
const getColorForIndex = (index) => {
  const round = Math.floor(index / AVATAR_COLORS.length);
  const positionInRound = index % AVATAR_COLORS.length;
  const colorIndices = AVATAR_COLORS.map((_, i) => i);
  const shuffled = shuffleWithSeed(colorIndices, round + 1);
  return AVATAR_COLORS[shuffled[positionInRound]];
};

export const CameraOffFace = ({ index = 0 }) => {
  const bgColor = getColorForIndex(index);
  const Face = FACES[index % FACES.length];

  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 321 180"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid slice"
    >
      <rect x="0.5" width="320" height="180" rx="12" fill={bgColor} />
      <g transform="translate(101.5, 31)">
        <Face />
      </g>
    </svg>
  );
};
